import GroupBettingPoolBuyBox from "../containers/group-betting-pool-buy-box";
import LightBox from "./light-box";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function EnterGroupBettingPoolLightbox({ groupBettingPool, onClose }) {
  return (
    <LightBox onClose={onClose} small title="Enter Player Pool">
      <div className="lightbox_body">
        <h3>
          {groupBettingPool.get("name")}
        </h3>

        <GroupBettingPoolBuyBox
          groupBettingPool={groupBettingPool}
          isGameBoard />
      </div>
    </LightBox>
  );
});
